import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { gdDeliveryBoyFeatures } from "../gdModulesData";
import GdImagePlaceholder from "./GdImagePlaceholder";

const GdDeliveryBoySection: React.FC = () => {
  return (
    <section className="gd-delivery" aria-labelledby="gd-delivery-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="gd-delivery-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Delivery Boy App
          </h2>
          <p className="gd-delivery__lead">
            A GPS integrated delivery boy app to track the geo-location of delivery boy.
          </p>
        </AnimatedSection>

        <div className="gd-delivery__layout">
          <ul className="gd-delivery__list">
            {gdDeliveryBoyFeatures.map((item, index) => (
              <motion.li
                key={item}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <span className="gd-delivery__dot" aria-hidden="true" />
                {item}
              </motion.li>
            ))}
          </ul>

          <AnimatedSection className="gd-delivery__visual" delay={0.1}>
            <GdImagePlaceholder
              variant="phones-dual"
              label="Delivery Boy App"
              hint="GPS navigation · Order details · Status updates"
              className="gd-delivery__placeholder"
            />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default GdDeliveryBoySection;
